import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'
if(process.env.REACT_APP_STAGE == 'prod')
{
    TagManager.initialize({
        gtmId: "GTM-5CK498X",
        dataLayerName: "CoppelDataLayer",
    });
    TagManager.initialize({
        gtmId: "GTM-TLSPTFH",
        dataLayerName: "CoppelDataLayer",
    });
}
ReactDOM.render( <BrowserRouter > <App /> </BrowserRouter>, document.getElementById('root'))
